import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';


@Component({
  selector: 'app-signs2-in-month-display',
  templateUrl: './signs2-in-month-display.component.html',
  styleUrls: ['./signs2-in-month-display.component.css']
})
export class Signs2InMonthDisplayComponent implements OnInit {

  @Input() preDayIcon!: string;
  @Input() postDayIcon!: string;
  @Input() currentIndexId!: number;
  @Input() preSignName!: string;
  @Input() postSignName!: string;
  @Input() currentMontName!: string;
  @Input() postColor!: string;
  @Input() preColor!: string;


  @Input() preElement!: string;
  @Input() preQuality!: string;
  @Input() preGlyph!: string;
  @Input() preHouse!: string;
  @Input() prePlanet!: string;

  @Input() postElement!: string;
  @Input() postQuality!: string;
  @Input() postGlyph!: string;
  @Input() postHouse!: string;
  @Input() postPlanet!: string;

  @Output() seeDifferentMonth: EventEmitter<any> = new EventEmitter();
  @Output() setDisplay: EventEmitter<any> = new EventEmitter();



  // @Input() preSignProfile!: object;
  // @Input() postSignProfile!: object;

  element: any ="";


  constructor() {
    // this.preSignProfile = {};
   }

  ngOnInit(): void {
    // console.log('presign obj', this.preSignProfile)
  }
  ngOnChanges(changes: SimpleChanges){
    this.setData();
  }

  setData(){

      // console.log('element check', this.preSignProfile.hasOwnProperty('family'));
      // if (this.preSignProfile.hasOwnProperty('family')){


      //   // this.element = this.preSignProfile.hasOwnProperty('family') ? this.preSignProfile : '';
      //   // console.log('its true', this.preSignProfile.hasOwnProperty('family'), 'element is', this.element );
      //   // this.preSignProfile = this.preSignProfile;
      //   // this.element = this.preSignProfile.family;
      // } else {
      //   null
      // }


    // this.element = this.preSignProfile.hasOwnProperty('family') ? this.preSignProfile.family : null;

  };

  prevMonth(){
    this.seeDifferentMonth.emit('prev');
  };
  nextMonth(){
    this.seeDifferentMonth.emit('next');
  };
  prevSign(){
    this.setDisplay.emit('show1prev');
  };
  postSign(){
    this.setDisplay.emit('show1post');
  }


}
